(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();

document.addEventListener('DOMContentLoaded', function () {
    // Selecciona el botón por su ID
    const triggerButton = document.getElementById('open-popup');
    
    // Verifica si el botón existe
    if (triggerButton) {
        triggerButton.addEventListener('click', function () {
            // Selecciona el popup correspondiente
            const popup = document.querySelector('[data-popup-id="open-popup"]');
            
            // Abre el popup si existe
            if (popup) {
                popup.classList.add('popup--active'); // Asegúrate de que 'popup--active' sea la clase correcta
            } else {
                console.error('No se encontró el popup con data-popup-id="open-popup"');
            }
        });
    }
});
